import { useEffect, useState } from "react";
import style from "./Sus.module.css";
import Dialog from "../dialogs/Dialog";

const Sus = (props) => {
  const [SUScores, setSUScores] = useState();

  useEffect(() => {
    let temp = [];
    for (let i in props.sus) {
      temp.push(props.sus[i]);
    }

    var sortedArray = temp.sort(callback);

    setSUScores(sortedArray);
  }, [props.sus]);

  function callback(a, b) {
    var aDate = a.month.split("-");
    var bDate = b.month.split("-");
    var newADate = new Date(aDate[2], aDate[1] - 1, aDate[0]);
    var newBDate = new Date(bDate[2], bDate[1] - 1, bDate[0]);

    if (newADate < newBDate) return -1;
    if (newADate > newBDate) return 1;
    return 0;
  }

  
  function openSus() {
    props.showDetails();
  }

  return (
    <>
      {SUScores ? (
        <div
          className={`${style.sus} ${
            style[SUScores[SUScores.length - 1].adjective]
          }`}
          onClick={openSus}
        >
          <div>SUS</div> {SUScores[SUScores.length - 1].value}
        </div>
      ) : null}
    </>
  );
};

export default Sus;
